import { render, staticRenderFns } from "./QuirofanoItem.vue?vue&type=template&id=26c66eb2&scoped=true&"
import script from "./QuirofanoItem.vue?vue&type=script&lang=js&"
export * from "./QuirofanoItem.vue?vue&type=script&lang=js&"
import style0 from "./QuirofanoItem.vue?vue&type=style&index=0&id=26c66eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c66eb2",
  null
  
)

export default component.exports